import { isEqual } from 'lodash';

export const removeFromArray = <Value>(array: Value[], index: number) => [
  ...array.slice(0, index),
  ...array.slice(index + 1),
];

export const insertIntoArray = <Value>(
  array: Value[],
  index: number,
  item: Value
) => [...array.slice(0, index), item, ...array.slice(index)];

export const moveInArray = <Value>(
  array: Value[],
  sourceIndex: number,
  targetIndex: number
) => {
  const item = array[sourceIndex];
  const delta = sourceIndex < targetIndex ? -1 : 0;

  return insertIntoArray(
    removeFromArray(array, sourceIndex),
    targetIndex + delta,
    item
  );
};

export const rotateArray = <Value>(
  array: Value[],
  reverse = false
): Value[] => {
  if (array.length <= 1) {
    return array;
  }

  if (!reverse) {
    // Rotate forward: move first element to end
    return [...array.slice(1), array[0]];
  }
  // Rotate backward: move last element to beginning
  return [array[array.length - 1], ...array.slice(0, -1)];
};

export const isSameSet = (
  first: Iterable<unknown>,
  second: Iterable<unknown>
) => isEqual(new Set(first), new Set(second));
